export const createHerbalSoapNavbarElements = (
  getHierarchyName,
  currentPageId,
  setClassStylesRegistry,
  setGlobalClassNames
) => {
  // Define class names for herbal soap navbar
  const navbarSectionClass = 'herbal-soap-navbar-section';
  const navbarContainerClass = 'herbal-soap-navbar-container';
  const navbarLogoClass = 'herbal-soap-navbar-logo';
  const navbarMenuClass = 'herbal-soap-navbar-menu';
  const navbarItemClass = 'herbal-soap-navbar-item';
  const navbarLinkClass = 'herbal-soap-navbar-link';
  const navbarSubmenuClass = 'herbal-soap-navbar-submenu';
  const navbarSubmenuItemClass = 'herbal-soap-navbar-submenu-item';
  const navbarSubmenuLinkClass = 'herbal-soap-navbar-submenu-link';
  const navbarContactBtnClass = 'herbal-soap-navbar-contact-btn';
  const navbarMobileToggleClass = 'herbal-soap-navbar-mobile-toggle';
  const navbarMobileToggleIconClass = 'herbal-soap-navbar-mobile-toggle-icon';
  const navbarActiveSubmenuClass = 'active-submenu';
  const navbarMobileMenuShowClass = 'navbar-mobilemenu-show';
  const navbarLinkArrowClass = 'navbar-link-arrow';
  const navbarLinkArrowUpClass = 'navbar-link-arrow-up';

  // Herbal/Organic themed styles with natural green and earth tones
  const navbarSectionStyles = {
    position: 'relative',
    top: '0',
    left: '0',
    right: '0',
    width: '100%',
    backgroundColor: 'rgba(26, 61, 26, 0.95)', // Matching hero's primary green
    background: `
      linear-gradient(135deg, rgba(26, 61, 26, 0.95) 0%, rgba(45, 90, 45, 0.95) 50%, rgba(34, 139, 34, 0.92) 100%),
      radial-gradient(circle at 20% 80%, rgba(144, 238, 144, 0.08) 0%, transparent 50%)
    `,
    backdropFilter: 'blur(15px)',
    boxShadow: '0 2px 20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(144, 238, 144, 0.1)',
    zIndex: '1000',
    transition: 'all 0.3s ease',
    borderBottom: '1px solid rgba(144, 238, 144, 0.15)'
  };

  const navbarContainerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '15px 30px'
  };

  const navbarLogoStyles = {
    fontSize: '28px',
    fontWeight: '600',
    color: '#ffffff',
    textDecoration: 'none',
    letterSpacing: '1px',
    fontFamily: '"Inter", sans-serif',
    transition: 'all 0.3s ease'
  };

  const navbarMenuStyles = {
    display: 'flex',
    listStyle: 'none',
    margin: '0',
    padding: '0',
    gap: '40px',
    alignItems: 'center'
  };

  const navbarItemStyles = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  };

  const navbarLinkStyles = {
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: '15px',
    fontWeight: '500',
    padding: '10px 0',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    letterSpacing: '0.5px',
    textTransform: 'capitalize',
    position: 'relative'
  };

  const navbarLinkHoverStyles = {
    color: '#90EE90', // Light green accent color for herbal theme
    transform: 'translateY(-1px)'
  };

  const navbarLinkArrowStyles = {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    marginLeft: '4px',
    border: '1px solid #ffffff',
    borderTop: 'none',
    borderLeft: 'none',
    transform: 'rotate(45deg)',
    transition: 'all 0.3s ease',
    opacity: '0.8'
  };

  const navbarLinkArrowUpStyles = {
    transform: 'rotate(-135deg)',
    marginTop: '3px'
  };

  const navbarSubmenuStyles = {
    position: 'absolute',
    top: '100%',
    left: '0',
    backgroundColor: 'rgba(34, 69, 34, 0.98)',
    backdropFilter: 'blur(15px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
    borderRadius: '8px',
    minWidth: '220px',
    padding: '20px 0',
    opacity: '0',
    visibility: 'hidden',
    transform: 'translateY(15px)',
    transition: 'all 0.4s ease',
    zIndex: '200',
    border: '1px solid rgba(144, 238, 144, 0.2)'
  };

  const navbarActiveSubmenuStyles = {
    opacity: '1',
    visibility: 'visible',
    transform: 'translateY(0)'
  };

  const navbarSubmenuItemStyles = {
    display: 'block',
    margin: '0',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
  };

  const navbarSubmenuLinkStyles = {
    display: 'block',
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: '13px',
    padding: '12px 25px',
    transition: 'all 0.3s ease',
    letterSpacing: '0.5px',
    textTransform: 'capitalize'
  };

  const navbarSubmenuLinkHoverStyles = {
    color: '#90EE90',
    backgroundColor: 'rgba(144, 238, 144, 0.1)',
    paddingLeft: '30px'
  };

  const navbarContactBtnStyles = {
    backgroundColor: '#90EE90',
    color: '#224522',
    padding: '12px 25px',
    border: '2px solid #90EE90',
    borderRadius: '6px',
    fontWeight: '600',
    fontSize: '13px',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    display: 'inline-block',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  };

  const navbarContactBtnHoverStyles = {
    backgroundColor: 'transparent',
    color: '#90EE90',
    transform: 'translateY(-2px)',
    boxShadow: '0 5px 15px rgba(144, 238, 144, 0.3)'
  };

  const navbarMobileToggleStyles = {
    display: 'none',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '10px',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const navbarMobileToggleIconStyles = {
    width: '25px',
    height: '2px',
    backgroundColor: '#ffffff',
    position: 'relative',
    transition: 'all 0.3s ease',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-8px',
      left: '0',
      width: '25px',
      height: '2px',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '8px',
      left: '0',
      width: '25px',
      height: '2px',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease'
    }
  };

  // Mobile menu show styles
  const navbarMobileMenuShowStyles = {
    display: 'flex'
  };

  // Mobile styles
  const mobileNavbarContainerStyles = {
    ...navbarContainerStyles,
    flexWrap: 'wrap',
    padding: '15px 20px',
    justifyContent: 'space-between'
  };

  const mobileNavbarLogoStyles = {
    ...navbarLogoStyles,
    order: '1'
  };

  const mobileNavbarMobileToggleStyles = {
    ...navbarMobileToggleStyles,
    display: 'flex',
    order: '2'
  };

  const mobileNavbarMenuStyles = {
    display: 'none',
    flexDirection: 'column',
    width: '100%',
    gap: '0',
    marginTop: '20px',
    backgroundColor: 'rgba(34, 69, 34, 0.98)',
    borderRadius: '8px',
    padding: '20px 0',
    order: '3'
  };

  const mobileNavbarItemStyles = {
    ...navbarItemStyles,
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '0'
  };

  const mobileNavbarLinkStyles = {
    ...navbarLinkStyles,
    padding: '15px 25px',
    width: '100%',
    justifyContent: 'space-between'
  };

  const mobileNavbarSubmenuStyles = {
    ...navbarSubmenuStyles,
    position: 'relative',
    top: '0',
    boxShadow: 'none',
    width: '100%',
    maxHeight: '0',
    overflow: 'hidden',
    padding: '0',
    transition: 'max-height 0.4s ease',
    opacity: '1',
    visibility: 'visible',
    transform: 'none',
    backgroundColor: 'rgba(144, 238, 144, 0.1)',
    border: 'none',
    borderRadius: '0'
  };

  const mobileNavbarActiveSubmenuStyles = {
    maxHeight: '500px',
    padding: '10px 0'
  };

  const mobileNavbarContactBtnStyles = {
    ...navbarContactBtnStyles,
    width: 'calc(100% - 50px)',
    textAlign: 'center',
    margin: '20px 25px 10px 25px'
  };

  // Hide contact button on mobile (it will be in the menu)
  const mobileNavbarContactBtnHiddenStyles = {
    display: 'none'
  };

  // Mobile-only menu item styles
  const mobileOnlyItemClass = 'mobile-only-item';
  const mobileOnlyItemStyles = {
    display: 'none'
  };

  const mobileOnlyItemMobileStyles = {
    display: 'flex'
  };

  // Mobile contact button in menu styles
  const mobileContactBtnInMenuStyles = {
    ...navbarContactBtnStyles,
    display: 'block',
    width: 'calc(100% - 50px)',
    textAlign: 'center',
    margin: '10px 25px',
    padding: '15px 25px'
  };

  // Tablet styles - Two row layout
  const tabletNavbarContainerStyles = {
    ...navbarContainerStyles,
    flexWrap: 'wrap',
    padding: '15px 25px',
    gap: '0'
  };

  const tabletNavbarMenuStyles = {
    ...navbarMenuStyles,
    gap: '25px',
    order: '3',
    width: '100%',
    justifyContent: 'center',
    marginTop: '0'
  };

  const tabletNavbarLogoStyles = {
    ...navbarLogoStyles,
    order: '1',
    flex: '1'
  };

  const tabletNavbarContactBtnStyles = {
    ...navbarContactBtnStyles,
    order: '2',
    marginLeft: 'auto'
  };

  const tabletNavbarMobileToggleStyles = {
    ...navbarMobileToggleStyles,
    display: 'none'
  };

  // Update the classStylesRegistry
  setClassStylesRegistry(prev => {
    const newRegistry = { ...prev };
    
    // Desktop styles
    newRegistry.desktop.set(navbarSectionClass, navbarSectionStyles);
    newRegistry.desktop.set(navbarContainerClass, navbarContainerStyles);
    newRegistry.desktop.set(navbarLogoClass, navbarLogoStyles);
    newRegistry.desktop.set(navbarMenuClass, navbarMenuStyles);
    newRegistry.desktop.set(navbarItemClass, navbarItemStyles);
    newRegistry.desktop.set(navbarLinkClass, navbarLinkStyles);
    newRegistry.desktop.set(navbarLinkClass + '--hover', navbarLinkHoverStyles);
    newRegistry.desktop.set(navbarLinkArrowClass, navbarLinkArrowStyles);
    newRegistry.desktop.set(navbarLinkArrowUpClass, navbarLinkArrowUpStyles);
    newRegistry.desktop.set(navbarSubmenuClass, navbarSubmenuStyles);
    newRegistry.desktop.set(navbarSubmenuItemClass, navbarSubmenuItemStyles);
    newRegistry.desktop.set(navbarSubmenuLinkClass, navbarSubmenuLinkStyles);
    newRegistry.desktop.set(navbarSubmenuLinkClass + '--hover', navbarSubmenuLinkHoverStyles);
    newRegistry.desktop.set(navbarContactBtnClass, navbarContactBtnStyles);
    newRegistry.desktop.set(navbarContactBtnClass + '--hover', navbarContactBtnHoverStyles);
    newRegistry.desktop.set(navbarMobileToggleClass, navbarMobileToggleStyles);
    newRegistry.desktop.set(navbarMobileToggleIconClass, navbarMobileToggleIconStyles);
    newRegistry.desktop.set(navbarActiveSubmenuClass, navbarActiveSubmenuStyles);
    newRegistry.desktop.set(navbarMobileMenuShowClass, navbarMobileMenuShowStyles);
    newRegistry.desktop.set(mobileOnlyItemClass, mobileOnlyItemStyles);

    // Tablet styles
    newRegistry.tablet.set(navbarMenuClass, tabletNavbarMenuStyles);
    newRegistry.tablet.set(navbarContainerClass, tabletNavbarContainerStyles);
    newRegistry.tablet.set(navbarLogoClass, tabletNavbarLogoStyles);
    newRegistry.tablet.set(navbarContactBtnClass, tabletNavbarContactBtnStyles);
    newRegistry.tablet.set(navbarMobileToggleClass, tabletNavbarMobileToggleStyles);
    newRegistry.tablet.set(mobileOnlyItemClass, mobileOnlyItemStyles);

    // Mobile styles
    newRegistry.mobile.set(navbarContainerClass, mobileNavbarContainerStyles);
    newRegistry.mobile.set(navbarLogoClass, mobileNavbarLogoStyles);
    newRegistry.mobile.set(navbarMenuClass, mobileNavbarMenuStyles);
    newRegistry.mobile.set(navbarMobileToggleClass, mobileNavbarMobileToggleStyles);
    newRegistry.mobile.set(navbarItemClass, mobileNavbarItemStyles);
    newRegistry.mobile.set(navbarLinkClass, mobileNavbarLinkStyles);
    newRegistry.mobile.set(navbarSubmenuClass, mobileNavbarSubmenuStyles);
    newRegistry.mobile.set(navbarActiveSubmenuClass, mobileNavbarActiveSubmenuStyles);
    newRegistry.mobile.set(navbarMobileMenuShowClass, navbarMobileMenuShowStyles);
    newRegistry.mobile.set(navbarContactBtnClass, mobileNavbarContactBtnHiddenStyles);
    newRegistry.mobile.set(mobileOnlyItemClass, mobileOnlyItemMobileStyles);
    newRegistry.mobile.set(navbarContactBtnClass + '-in-menu', mobileContactBtnInMenuStyles);
    
    return newRegistry;
  });

  // Add classes to globalClassNames
  setGlobalClassNames(prev => new Set([
    ...prev,
    navbarSectionClass,
    navbarContainerClass,
    navbarLogoClass,
    navbarMenuClass,
    navbarItemClass,
    navbarLinkClass,
    navbarLinkArrowClass,
    navbarLinkArrowUpClass,
    navbarSubmenuClass,
    navbarSubmenuItemClass,
    navbarSubmenuLinkClass,
    navbarContactBtnClass,
    navbarContactBtnClass + '-in-menu',
    navbarMobileToggleClass,
    navbarMobileToggleIconClass,
    navbarActiveSubmenuClass,
    navbarMobileMenuShowClass,
    mobileOnlyItemClass,
  ]));

  // Generate IDs for all elements
  const navbarSectionId = Date.now();
  const navbarContainerId = navbarSectionId + 1;
  const navbarLogoId = navbarSectionId + 2;
  const navbarMenuId = navbarSectionId + 3;
  const navbarContactBtnId = navbarSectionId + 4;
  const navbarMobileToggleId = navbarSectionId + 5;

  // Herbal soap specific menu items
  const menuItems = [
    { name: 'Home', link: '#', linkTo: 'index', hasSubmenu: false },
    { name: 'Products', link: '#', hasSubmenu: true, submenuItems: [
      { name: 'Herbal Soap', link: '#', linkTo: 'herbal-soap' },
      { name: 'Organic Ubtan', link: '#', linkTo: 'herbal-ubtan' },
      { name: 'Natural Facewash', link: '#', linkTo: 'herbal-facewash' },
    ]},
    { name: 'About', link: '#', linkTo: 'about', hasSubmenu: false },
    { name: 'Ingredients', link: '#', linkTo: 'ingredients', hasSubmenu: false },
    { name: 'Contact', link: '#', linkTo: 'contact', hasSubmenu: false },
    { name: 'Shop Now', link: '#', linkTo: 'order', hasSubmenu: false, isMobileOnly: true, isContactBtn: true }
  ];

  // Create element IDs for menu items and submenus
  let currentId = navbarMobileToggleId + 1;
  const menuItemElements = [];

  menuItems.forEach((item, index) => {
    const menuItemId = currentId++;
    const linkId = currentId++;
    let submenuId = null;
    let arrowIconId = null;
    const submenuItems = [];

    if (item.hasSubmenu) {
      submenuId = currentId++;
      arrowIconId = currentId++;
      
      // Create submenu items
      item.submenuItems.forEach(submenuItem => {
        const submenuItemId = currentId++;
        const submenuLinkId = currentId++;
        
        submenuItems.push({
          id: submenuItemId,
          builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          type: 'li',
          hierarchyName: `${item.name} Submenu Item - ${submenuItem.name}`,
          parentId: submenuId,
          className: navbarSubmenuItemClass,
          styles: {},
          children: [submenuLinkId],
          text: '',
          visibility: 'visible',
          isExpanded: true,
          attributes: {
            'data-element': 'navbar-submenu-item'
          }
        });

        submenuItems.push({
          id: submenuLinkId,
          builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          type: 'link',
          hierarchyName: `${submenuItem.name} Link`,
          parentId: submenuItemId,
          className: navbarSubmenuLinkClass,
          styles: {},
          children: [],
          text: submenuItem.name,
          visibility: 'visible',
          isExpanded: true,
          linkTo: submenuItem.linkTo,
          attributes: {
            'data-element': 'navbar-submenu-link',
            'href': submenuItem.link
          }
        });
      });
    }

    // Create menu item element
    menuItemElements.push({
      id: menuItemId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'li',
      hierarchyName: `${item.name} Menu Item`,
      parentId: navbarMenuId,
      className: item.isMobileOnly ? `${navbarItemClass} mobile-only-item` : navbarItemClass,
      styles: item.isMobileOnly ? { display: 'none' } : {},
      children: item.hasSubmenu ? [linkId, submenuId] : [linkId],
      text: '',
      visibility: 'visible',
      isExpanded: true,
      linkTo: item.linkTo,
      attributes: {
        'data-element': 'navbar-item',
        'data-has-submenu': item.hasSubmenu.toString(),
        'data-mobile-only': item.isMobileOnly ? 'true' : 'false'
      },
      // Add hover interaction for submenu
      interactions: item.hasSubmenu ? {
        events: [
          {
            id: Date.now() + index,
            type: 'hover',
            action: 'toggleClass',
            direction: 'in',
            label: `Hover In: Add active class to submenu`,
            value: {
              targetId: submenuId,
              transitionDuration: '0.3s',
              className: navbarActiveSubmenuClass
            }
          },
          {
            id: Date.now() + index + 1000,
            type: 'hover',
            action: 'toggleClass',
            direction: 'out',
            label: `Hover Out: Remove active class from submenu`,
            value: {
              targetId: submenuId,
              className: navbarActiveSubmenuClass,
              remove: true
            }
          },
          {
            id: Date.now() + index + 2000,
            type: 'hover',
            action: 'toggleClass',
            direction: 'in',
            label: `Hover In: Rotate arrow icon`,
            value: {
              targetId: arrowIconId,
              className: navbarLinkArrowUpClass
            }
          },
          {
            id: Date.now() + index + 3000,
            type: 'hover',
            action: 'toggleClass',
            direction: 'out',
            label: `Hover Out: Restore arrow icon`,
            value: {
              targetId: arrowIconId,
              className: navbarLinkArrowUpClass,
              remove: true
            }
          }
        ]
      } : {}
    });

    // Create menu item link
    if (item.hasSubmenu) {
      menuItemElements.push({
        id: linkId,
        builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        type: 'link',
        hierarchyName: `${item.name} Link`,
        parentId: menuItemId,
        className: navbarLinkClass,
        styles: {},
        children: [arrowIconId],
        text: item.name,
        visibility: 'visible',
        isExpanded: true,
        attributes: {
          'data-element': 'navbar-link',
          'href': item.link
        }
      });

      // Create arrow icon element
      menuItemElements.push({
        id: arrowIconId,
        builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        type: 'span',
        hierarchyName: `${item.name} Arrow Icon`,
        parentId: linkId,
        className: navbarLinkArrowClass,
        styles: {},
        children: [],
        text: '',
        visibility: 'visible',
        isExpanded: true,
        attributes: {
          'data-element': 'navbar-link-arrow',
          'aria-hidden': 'true'
        }
      });
    } else {
      menuItemElements.push({
        id: linkId,
        builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        type: 'link',
        hierarchyName: `${item.name} Link`,
        parentId: menuItemId,
        className: item.isContactBtn ? `${navbarContactBtnClass} ${navbarContactBtnClass}-in-menu` : navbarLinkClass,
        styles: {},
        children: [],
        text: item.name,
        visibility: 'visible',
        isExpanded: true,
        linkTo: item.linkTo,
        attributes: {
          'data-element': item.isContactBtn ? 'navbar-contact-btn' : 'navbar-link',
          'href': item.link
        }
      });
    }

    // Create submenu if needed
    if (item.hasSubmenu) {
      menuItemElements.push({
        id: submenuId,
        builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        type: 'ul',
        hierarchyName: `${item.name} Submenu`,
        parentId: menuItemId,
        className: navbarSubmenuClass,
        styles: {},
        children: submenuItems.filter(item => item.type === 'li').map(item => item.id),
        text: '',
        visibility: 'visible',
        isExpanded: true,
        attributes: {
          'data-element': 'navbar-submenu'
        }
      });

      // Add submenu items to the elements array
      menuItemElements.push(...submenuItems);
    }
  });

  const elementIdsForMenu = menuItemElements
    .filter(element => element.parentId === navbarMenuId)
    .map(element => element.id);

  // Create base navbar elements
  const baseElements = [
    // Main Navbar Section
    {
      id: navbarSectionId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'nav',
      hierarchyName: 'Herbal Soap Navbar Section',
      parentId: null,
      className: navbarSectionClass,
      styles: {},
      children: [navbarContainerId],
      text: '',
      visibility: 'visible',
      isExpanded: true,
      attributes: {
        'data-element': 'navbar-section',
        'data-component': 'nav',
        'data-section-type': 'navbar',
        'data-page-id': currentPageId,
        'role': 'navigation',
        'aria-label': 'Main navigation'
      }
    },
    // Container
    {
      id: navbarContainerId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'div',
      hierarchyName: 'Herbal Soap Navbar Container',
      parentId: navbarSectionId,
      className: navbarContainerClass,
      styles: {},
      children: [navbarLogoId, navbarMobileToggleId, navbarMenuId, navbarContactBtnId],
      text: '',
      visibility: 'visible',
      isExpanded: true,
      attributes: {
        'data-element': 'navbar-container'
      }
    },
    // Logo
    {
      id: navbarLogoId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'link',
      hierarchyName: 'Herbal Soap Logo',
      parentId: navbarContainerId,
      className: navbarLogoClass,
      styles: {},
      children: [],
      text: 'HerbalSoap',
      visibility: 'visible',
      isExpanded: true,
      linkTo: 'index',
      attributes: {
        'data-element': 'navbar-logo',
        'href': '#'
      }
    },
    // Contact Button
    {
      id: navbarContactBtnId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'link',
      hierarchyName: 'Shop Now Button',
      parentId: navbarContainerId,
      className: navbarContactBtnClass,
      styles: {},
      children: [],
      text: 'Shop Now',
      visibility: 'visible',
      isExpanded: true,
      linkTo: 'order',
      attributes: {
        'data-element': 'navbar-contact-btn',
        'role': 'button'
      }
    },
    // Mobile Toggle Button
    {
      id: navbarMobileToggleId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'link',
      hierarchyName: 'Mobile Toggle',
      parentId: navbarContainerId,
      className: navbarMobileToggleClass,
      styles: {},
      children: [navbarMobileToggleId + 100],
      text: '',
      visibility: 'visible',
      isExpanded: true,
      attributes: {
        'data-element': 'navbar-mobile-toggle',
        'aria-label': 'Toggle navigation menu'
      },
      interactions: {
        events: [
          {
            id: Date.now() + 100,
            type: 'click',
            action: 'toggleClass',
            sequence: 'first',
            label: '1st Click: Toggle Class: navbar-mobilemenu-show on navbar-menu',
            value: {
              targetId: navbarMenuId,
              className: navbarMobileMenuShowClass
            }
          },
          {
            id: Date.now() + 101,
            type: 'click',
            action: 'toggleClass',
            sequence: 'second',
            label: '2nd Click: Toggle Class: navbar-mobilemenu-hide on navbar-menu',
            value: {
              targetId: navbarMenuId,
              className: navbarMobileMenuShowClass
            }
          }
        ]
      }
    },
    // Mobile Toggle Icon
    {
      id: navbarMobileToggleId + 100,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'span',
      hierarchyName: 'Mobile Toggle Icon',
      parentId: navbarMobileToggleId,
      className: navbarMobileToggleIconClass,
      styles: {},
      children: [],
      text: '',
      visibility: 'visible',
      isExpanded: true,
      attributes: {
        'data-element': 'navbar-mobile-toggle-icon',
        'aria-hidden': 'true'
      }
    },
    // Menu Container
    {
      id: navbarMenuId,
      builderId: `builder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      type: 'ul',
      hierarchyName: 'Herbal Soap Navbar Menu',
      parentId: navbarContainerId,
      className: navbarMenuClass,
      styles: {},
      children: elementIdsForMenu,
      text: '',
      visibility: 'visible',
      isExpanded: true,
      attributes: {
        'data-element': 'navbar-menu'
      }
    }
  ];

  // Combine all elements
  const allElements = [...baseElements, ...menuItemElements];
  
  // Return the created elements
  return {
    elements: allElements
  };
}; 